export default __webpack_public_path__ + "static/media/offline10.b62814bf.png";